import { MutateResponse, useMutateRequest } from 'hooks/useRequest';
import { useMutation } from '@tanstack/react-query';
import {
  NotificationsApi_markAllNotificationsAsRead,
  NotificationsApi_markAllNotificationsAsRead$Params,
  NotificationsApi_markAllNotificationsAsRead$Response,
} from 'api-client';
import queryClient from 'utils/helpers/queryClient';
import { queryKey as countQueryKey } from '../useGetNotificationCount';
import { queryKey as listQueryKey } from '../useGetNotifications';

const keysToInvalidate = [countQueryKey, listQueryKey];

const useMarkAllNotificationsAsRead = (): MutateResponse<
  NotificationsApi_markAllNotificationsAsRead$Params,
  NotificationsApi_markAllNotificationsAsRead$Response
> => {
  const { mutateAsync, isLoading, error, data } = useMutation(
    NotificationsApi_markAllNotificationsAsRead,
    {
      // invalidate notification queries
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) =>
            keysToInvalidate.includes(query.queryKey[0] as string),
        });
      },
    }
  );

  return [
    useMutateRequest(mutateAsync),
    data,
    error as null | Error,
    isLoading,
  ];
};

export default useMarkAllNotificationsAsRead;
